import React, { Component } from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';

class Faq extends Component {
    render() {
        return (
            <View>
                <Text style={styles.remarks}>
                    {
                        "1. How to find out those xxxxId?"
                        + "\n\n"
                        + "Web Service for finding ID is provided. For detailed tutorial, Please refer to "
                    }
                    <TouchableOpacity onPress={() => this.props.onPress(3)}>
                        <View>
                            <Text style={styles.hyperlink}>
                                {
                                    "M18 – Search"
                                }
                            </Text>
                        </View>
                    </TouchableOpacity>
                    {
                        "."
                    }
                </Text>
                <Text style={[styles.remarks, { paddingBottom: 20 }]}>
                    {
                        "2. How to understand the error info from the response?"
                        + "\n\n"
                        + "You can read the error_info.messageData.info_desc for the exact reason. If it is not clear enough, please enquire our Support and provide us the below error message from your response."
                    }
                </Text>
                <View style={{ borderWidth: 1 }}>
                    <Text style={[styles.remarks, { paddingLeft: 30, paddingBottom: 20 }]}>
                        {
                            '{'
                            + "\n"
                            + '    error_info: {'
                            + "\n"
                            + '                 "autoClose":true'
                            + "\n"
                            + '                 "closable":true'
                            + "\n"
                            + '                 "delayClose":3000,'
                            + "\n"
                            + '                 "detailSet":false,'
                            + "\n"
                            + '                 "htmlMessage":false,'
                            + "\n"
                            + '                 "locator": [ {"locator":"sot.qty."2"} ],'
                            + "\n"
                            + '                 "messageData": {'
                            + "\n"
                            + '                             "exception":"", "htmlMessage":false'
                            + "\n"
                            + '                             "id":101203,'
                            + "\n"
                            + '                             "info_desc":"<Quantity> of <Product> cannot be 0",'
                            + "\n"
                            + '                             "jsonStr":"",'
                            + "\n"
                            + '                             "key":"ce01_core_101203",'
                            + "\n"
                            + '                             "locators": [ {'
                            + "\n"
                            + '                                     "colName":"qty",'
                            + "\n"
                            + '                                     "id":0,'
                            + "\n"
                            + '                                     "locatorKey":"sot.qty.2",'
                            + "\n"
                            + '                                     "row":2,'
                            + "\n"
                            + '                                     "tableName":"sot",'
                            + "\n"
                            + '                                     "type":"Field" } ],'
                            + "\n"
                            + '                             "pass":false,'
                            + "\n"
                            + '                             "trace":"'
                            + "\n"
                            + '                                          [TradeModuleChecker.checkSetting_791]-'
                            + "\n"
                            + '                                          [CheckerLib.runChecker_225]-'
                            + "\n"
                            + '                                          [CawEntityCurdAction.updateEntity_107]-'
                            + "\n"
                            + '                                          [CawEntityInterceptor.logCall_42]-'
                            + "\n"
                            + '                                          [view129.updateEntity_-1]'
                            + "\n"
                            + '                             ",'
                            + "\n"
                            + '                             "type":"Error"'
                            + "\n"
                            + '                 },'
                            + "\n"
                            + '                 "messageKey":"ce01_core_101203",'
                            + "\n"
                            + '                 "type":"ERROR"'
                            + "\n"
                            + '     }'
                            + "\n"
                            + '}'
                        }
                    </Text>
                </View>
            </View>
        )
    }
}

const styles = StyleSheet.create({
    remarks: {
        width: 680,
        borderWidth: 1,
        paddingTop: 20,
    },
    text: {
        margin: 6,
        backgroundColor: 'transparent',
        fontSize: 10
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
});

export default Faq;



// WEBPACK FOOTER //
// ./src/pages/ch4/Faq.js